import React, { useState, useEffect } from "react";
import "./AdminPage.css";

const PricingAdmin = ({ vehicles, API_BASE_URL }) => {
  const [activeSubTab, setActiveSubTab] = useState("published_price");
  const [loading, setLoading] = useState(false);

  // States
  const [promotions, setPromotions] = useState([]);
  const [fees, setFees] = useState([]);
  
  // Published Price States
  const [vehicleId, setVehicleId] = useState("");
  const [variantId, setVariantId] = useState("");
  const [variants, setVariants] = useState([]);
  const [publishedPrice, setPublishedPrice] = useState("");

  const formatNum = (val) => {
    if (!val && val !== 0) return "";
    return parseInt(val.toString().replace(/\D/g, "") || "0", 10).toLocaleString("vi-VN");
  };
  const parseNum = (val) => {
    if (!val) return "0";
    return val.toString().replace(/\D/g, "");
  };

  useEffect(() => {
    loadPricingRules();
  }, []);

  const loadPricingRules = async () => {
    try {
      const resPromo = await fetch(`${API_BASE_URL}/admin/pricing-rules/promotions`);
      const promos = await resPromo.json();
      setPromotions(promos);

      const resFee = await fetch(`${API_BASE_URL}/admin/pricing-rules/fees`);
      const feesData = await resFee.json();
      setFees(feesData);
    } catch (error) {
      console.error(error);
      alert("Lỗi tải quy tắc giá");
    }
  };

  const handleSelectVehicle = async (vId) => {
    setVehicleId(vId);
    setVariantId("");
    setPublishedPrice("");
    if (!vId) {
      setVariants([]);
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/vehicles/${vId}`);
      const data = await res.json();
      setVariants(data.variants || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectVariant = async (varId) => {
    setVariantId(varId);
    if (!varId) {
      setPublishedPrice("");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/admin/prices/${varId}`);
      const data = await res.json();
      setPublishedPrice(data?.published_price || "");
    } catch (e) {
      console.error(e);
      setPublishedPrice("");
    }
  };

  const savePublishedPrice = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/prices`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          variant_id: variantId,
          published_price: publishedPrice || 0,
        }),
      });
      if (res.ok) alert("Cập nhật giá công bố thành công");
      else alert("Lỗi cập nhật");
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const updatePromotion = async (promo) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/promotions/${promo.promo_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(promo)
      });
      if (res.ok) {
        alert("Cập nhật thành công");
        loadPricingRules();
      } else {
        alert("Lỗi cập nhật");
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const savePromotion = async (promo) => {
    if (promo.isNew) {
      if (!promo.promo_code || !promo.promo_name) {
        alert("Vui lòng nhập mã và tên khuyến mãi");
        return;
      }
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/promotions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(promo)
        });
        if (res.ok) {
          alert("Tạo khuyến mãi thành công");
          loadPricingRules();
        } else {
          alert("Lỗi tạo khuyến mãi");
        }
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    } else {
      updatePromotion(promo);
    }
  };

  const deletePromotion = async (promo) => {
    if (promo.isNew) {
      setPromotions(promotions.filter(p => p.promo_id !== promo.promo_id));
      return;
    }
    if (!window.confirm(`Bạn có chắc chắn muốn xóa khuyến mãi ${promo.promo_name}?`)) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/promotions/${promo.promo_id}`, {
        method: "DELETE"
      });
      if (res.ok) {
        alert("Xóa thành công");
        loadPricingRules();
      } else {
        alert("Lỗi xóa khuyến mãi. Có thể khuyến mãi này là mặc định hệ thống.");
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const updateFee = async (fee) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/fees/${fee.fee_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fee)
      });
      if (res.ok) {
        alert("Cập nhật thành công");
        loadPricingRules();
      } else {
        alert("Lỗi cập nhật");
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const saveFee = async (fee) => {
    if (fee.isNew) {
      if (!fee.fee_code || !fee.fee_name) {
        alert("Vui lòng nhập mã và tên chi phí");
        return;
      }
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/fees`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(fee)
        });
        if (res.ok) {
          alert("Tạo chi phí thành công");
          loadPricingRules();
        } else {
          alert("Lỗi tạo chi phí");
        }
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    } else {
      updateFee(fee);
    }
  };

  const deleteFee = async (fee) => {
    if (fee.isNew) {
      setFees(fees.filter(f => f.fee_id !== fee.fee_id));
      return;
    }
    if (!window.confirm(`Bạn có chắc chắn muốn xóa chi phí ${fee.fee_name}?`)) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admin/pricing-rules/fees/${fee.fee_id}`, {
        method: "DELETE"
      });
      if (res.ok) {
        alert("Xóa thành công");
        loadPricingRules();
      } else {
        alert("Lỗi xóa chi phí.");
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const addFeeRow = () => {
    const newFee = {
      fee_id: "new_" + Date.now(),
      fee_code: "",
      fee_name: "",
      fee_type: "per_vehicle",
      amount: 0,
      vehicles: [],
      isNew: true
    };
    setFees([newFee, ...fees]);
  };

  return (
    <div className="tab-content">
      <h2>Quản Lý Giá & Khuyến Mãi</h2>
      
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button className={`btn ${activeSubTab === 'published_price' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setActiveSubTab('published_price')}>Giá Công Bố</button>
        <button className={`btn ${activeSubTab === 'promotions' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setActiveSubTab('promotions')}>Khuyến Mãi</button>
        <button className={`btn ${activeSubTab === 'fees' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setActiveSubTab('fees')}>Chi Phí Khác</button>
      </div>

      {activeSubTab === "published_price" && (
        <div className="form-section">
          <h3>Giá Công Bố Theo Phiên Bản</h3>
          <div className="form-group">
            <label>Chọn Xe</label>
            <select value={vehicleId} onChange={e => handleSelectVehicle(e.target.value)}>
              <option value="">-- Chọn xe --</option>
              {vehicles.map(v => <option key={v.vehicle_id} value={v.vehicle_id}>{v.vehicle_name}</option>)}
            </select>
          </div>
          {variants.length > 0 && (
            <div className="form-group">
              <label>Chọn Phiên Bản</label>
              <select value={variantId} onChange={e => handleSelectVariant(e.target.value)}>
                <option value="">-- Chọn phiên bản --</option>
                {variants.map(v => <option key={v.variant_id} value={v.variant_id}>{v.variant_name}</option>)}
              </select>
            </div>
          )}
          {variantId && (
            <div className="form-group">
              <label>Giá Công Bố (VNĐ)</label>
              <input type="text" value={formatNum(publishedPrice)} onChange={e => setPublishedPrice(parseNum(e.target.value))} />
              <button style={{marginTop: 15}} className="btn btn-primary" onClick={savePublishedPrice} disabled={loading}>Lưu Giá</button>
            </div>
          )}
        </div>
      )}

      {activeSubTab === "promotions" && (
        <div className="form-section">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Cấu Hình Khuyến Mãi (%)</h3>
            <button className="btn btn-primary btn-small" onClick={() => {
              const newPromo = {
                promo_id: 'new_' + Date.now(),
                promo_code: `PROMO_${Date.now()}`,
                promo_name: 'Khuyến mãi mới',
                is_active: 1,
                is_default: 0,
                discount_type: 'percentage',
                discount_percentage: 0,
                discount_amount: 0,
                vehicles: [],
                isNew: true
              };
              setPromotions([newPromo, ...promotions]);
            }}>+ Thêm Khuyến Mãi</button>
          </div>
          {promotions.map(promo => (
            <div key={promo.promo_id} style={{ border: '1px solid #ddd', padding: 15, marginBottom: 15, borderRadius: 8 }}>
              {promo.isNew ? (
                <div className="form-group" style={{ marginBottom: '15px' }}>
                  <label>Mã Khuyến Mãi (Không dấu, viết liền):</label>
                  <input type="text" value={promo.promo_code} onChange={e => {
                    const updated = [...promotions];
                    updated.find(p => p.promo_id === promo.promo_id).promo_code = e.target.value.toUpperCase();
                    setPromotions(updated);
                  }} style={{ marginBottom: '10px' }} />
                  <label>Tên Khuyến Mãi:</label>
                  <input type="text" value={promo.promo_name} onChange={e => {
                    const updated = [...promotions];
                    updated.find(p => p.promo_id === promo.promo_id).promo_name = e.target.value;
                    setPromotions(updated);
                  }} />
                </div>
              ) : (
                <h4>{promo.promo_name} {promo.is_default ? "(Mặc định)" : ""}</h4>
              )}
              <div style={{ display: 'flex', gap: 15, alignItems: 'center', marginBottom: 10 }}>
                <label><input type="checkbox" checked={promo.is_active} onChange={e => {
                  const updated = [...promotions];
                  updated.find(p => p.promo_id === promo.promo_id).is_active = e.target.checked ? 1 : 0;
                  setPromotions(updated);
                }} /> Áp dụng (Active)</label>
                <label><input type="checkbox" checked={promo.is_default === 1} onChange={e => {
                  const updated = [...promotions];
                  updated.find(p => p.promo_id === promo.promo_id).is_default = e.target.checked ? 1 : 0;
                  setPromotions(updated);
                }} /> Mặc định chọn sẵn</label>
              </div>
              <div className="form-group">
                <label>Áp dụng cho dòng xe:</label>
                <div style={{ marginBottom: 10, marginTop: 10 }}>
                  <button className="btn-small btn-outline" onClick={() => {
                    const updated = [...promotions];
                    const p = updated.find(x => x.promo_id === promo.promo_id);
                    if (p.vehicles && p.vehicles.length === vehicles.length) {
                      p.vehicles = [];
                    } else {
                      p.vehicles = vehicles.map(v => {
                        const existing = (p.vehicles || []).find(x => x.vehicle_id === v.vehicle_id);
                        return {
                          vehicle_id: v.vehicle_id,
                          discount_type: existing ? existing.discount_type : 'percentage',
                          discount_percentage: existing ? existing.discount_percentage : 0,
                          discount_amount: existing ? existing.discount_amount : 0
                        };
                      });
                    }
                    setPromotions(updated);
                  }}>
                    {promo.vehicles && promo.vehicles.length === vehicles.length ? "Bỏ chọn tất cả" : "Chọn tất cả các dòng xe"}
                  </button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 15, marginTop: 10, background: 'rgba(255, 255, 255, 0.05)', padding: 15, borderRadius: 8, border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                  {vehicles.map(v => {
                    const vPromo = (promo.vehicles || []).find(x => x.vehicle_id === v.vehicle_id);
                    const isChecked = !!vPromo;
                    const pct = vPromo ? vPromo.discount_percentage : 0;
                    return (
                      <div key={v.vehicle_id} style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
                        <label style={{ width: 150 }}>
                          <input type="checkbox" checked={isChecked} onChange={e => {
                            const updated = [...promotions];
                            const p = updated.find(x => x.promo_id === promo.promo_id);
                            if (!p.vehicles) p.vehicles = [];
                            if (e.target.checked) p.vehicles.push({ vehicle_id: v.vehicle_id, discount_type: 'percentage', discount_percentage: 0, discount_amount: 0 });
                            else p.vehicles = p.vehicles.filter(id => id.vehicle_id !== v.vehicle_id);
                            setPromotions(updated);
                          }} /> {v.vehicle_name}
                        </label>
                        {isChecked && (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                            <select value={vPromo?.discount_type || 'percentage'} onChange={e => {
                                const updated = [...promotions];
                                const p = updated.find(x => x.promo_id === promo.promo_id);
                                const vp = p.vehicles.find(x => x.vehicle_id === v.vehicle_id);
                                if (vp) vp.discount_type = e.target.value;
                                setPromotions(updated);
                            }}>
                              <option value="percentage">Theo %</option>
                              <option value="amount">Số tiền (VNĐ)</option>
                            </select>
                            {vPromo?.discount_type === 'amount' ? (
                              <input type="text" placeholder="Nhập số tiền" value={formatNum(vPromo?.discount_amount || 0)} onChange={e => {
                                const updated = [...promotions];
                                const p = updated.find(x => x.promo_id === promo.promo_id);
                                const vp = p.vehicles.find(x => x.vehicle_id === v.vehicle_id);
                                if (vp) vp.discount_amount = parseNum(e.target.value);
                                setPromotions(updated);
                              }} />
                            ) : (
                              <input type="number" step="0.01" placeholder="Nhập tỷ lệ %" value={pct} onChange={e => {
                                const updated = [...promotions];
                                const p = updated.find(x => x.promo_id === promo.promo_id);
                                const vp = p.vehicles.find(x => x.vehicle_id === v.vehicle_id);
                                if (vp) vp.discount_percentage = e.target.value;
                                setPromotions(updated);
                              }} />
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn-small btn-primary" onClick={() => savePromotion(promo)} disabled={loading}>Lưu Thay Đổi</button>
                {promo.promo_code !== 'XEVF' && (
                  <button className="btn-small btn-delete" onClick={() => deletePromotion(promo)} disabled={loading}>Xóa</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {activeSubTab === "fees" && (
        <div className="form-section">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Cấu Hình Chi Phí Khác</h3>
            <button className="btn-small btn-primary" onClick={addFeeRow}>+ Thêm Chi Phí Mới</button>
          </div>
          {fees.map(fee => (
            <div key={fee.fee_id} style={{ border: '1px solid #ddd', padding: 15, marginBottom: 15, borderRadius: 8 }}>
              
              {fee.isNew ? (
                <div style={{ display: 'flex', gap: 15, marginBottom: 15 }}>
                  <input 
                    type="text" 
                    placeholder="Mã chi phí (vd: FEE_CUSTOM_1)" 
                    value={fee.fee_code} 
                    onChange={e => {
                      const updated = [...fees];
                      updated.find(f => f.fee_id === fee.fee_id).fee_code = e.target.value.toUpperCase();
                      setFees(updated);
                    }} 
                    style={{ flex: 1 }}
                  />
                  <input 
                    type="text" 
                    placeholder="Tên chi phí" 
                    value={fee.fee_name} 
                    onChange={e => {
                      const updated = [...fees];
                      updated.find(f => f.fee_id === fee.fee_id).fee_name = e.target.value;
                      setFees(updated);
                    }} 
                    style={{ flex: 2 }}
                  />
                  <select 
                    value={fee.fee_type} 
                    onChange={e => {
                      const updated = [...fees];
                      updated.find(f => f.fee_id === fee.fee_id).fee_type = e.target.value;
                      setFees(updated);
                    }}
                  >
                    <option value="per_vehicle">Cấu hình theo xe (Giống màu VIP)</option>
                    <option value="global">Áp dụng chung</option>
                  </select>
                </div>
              ) : (
                <h4>{fee.fee_name} ({fee.fee_type === 'global' ? 'Áp dụng chung' : 'Cấu hình theo xe'})</h4>
              )}
              
              {fee.fee_type === 'global' ? (
                <div style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
                  <label>Số tiền (VNĐ):</label>
                  <input type="text" value={formatNum(fee.amount)} onChange={e => {
                    const updated = [...fees];
                    updated.find(f => f.fee_id === fee.fee_id).amount = parseNum(e.target.value);
                    setFees(updated);
                  }} />
                </div>
              ) : (
                <div className="form-group" style={{ marginTop: 15 }}>
                  <label>Áp dụng cho dòng xe (Cấu hình VNĐ):</label>
                  <div style={{ marginBottom: 10, marginTop: 10 }}>
                    <button className="btn-small btn-outline" onClick={() => {
                      const updated = [...fees];
                      const f = updated.find(x => x.fee_id === fee.fee_id);
                      if (f.vehicles && f.vehicles.length === vehicles.length) {
                        f.vehicles = [];
                      } else {
                        f.vehicles = vehicles.map(v => {
                          const existing = (f.vehicles || []).find(x => x.vehicle_id === v.vehicle_id);
                          return {
                            vehicle_id: v.vehicle_id,
                            amount: existing ? existing.amount : 0
                          };
                        });
                      }
                      setFees(updated);
                    }}>
                      {fee.vehicles && fee.vehicles.length === vehicles.length ? "Bỏ chọn tất cả" : "Chọn tất cả các dòng xe"}
                    </button>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 15, marginTop: 10, background: 'rgba(255, 255, 255, 0.05)', padding: 15, borderRadius: 8, border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                  {vehicles.map(v => {
                    const vFee = (fee.vehicles || []).find(x => x.vehicle_id === v.vehicle_id);
                    const isChecked = !!vFee;
                    const amount = vFee ? vFee.amount : 0;
                    return (
                      <div key={v.vehicle_id} style={{ display: 'flex', gap: 15, alignItems: 'center', marginBottom: 10 }}>
                        <label style={{ width: 150 }}>
                          <input type="checkbox" checked={isChecked} onChange={e => {
                            const updated = [...fees];
                            const f = updated.find(x => x.fee_id === fee.fee_id);
                            if (!f.vehicles) f.vehicles = [];
                            if (e.target.checked) f.vehicles.push({ vehicle_id: v.vehicle_id, amount: 0 });
                            else f.vehicles = f.vehicles.filter(id => id.vehicle_id !== v.vehicle_id);
                            setFees(updated);
                          }} /> {v.vehicle_name}
                        </label>
                        {isChecked && (
                          <input type="text" placeholder="Nhập số tiền VNĐ" value={formatNum(amount)} onChange={e => {
                            const updated = [...fees];
                            const f = updated.find(x => x.fee_id === fee.fee_id);
                            const vf = f.vehicles.find(x => x.vehicle_id === v.vehicle_id);
                            if (vf) vf.amount = parseNum(e.target.value);
                            setFees(updated);
                          }} />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              )}
              <div style={{ display: 'flex', gap: 10, marginTop: 15 }}>
                <button className="btn-small btn-primary" onClick={() => saveFee(fee)} disabled={loading}>Lưu Thay Đổi</button>
                {['FEE_HCM_HN', 'FEE_PROV', 'FEE_VIP_COLOR'].includes(fee.fee_code) === false && (
                  <button className="btn-small btn-delete" onClick={() => deleteFee(fee)} disabled={loading}>Xóa</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PricingAdmin;
